import type { Workspace } from '@/entities/workspace';
import { can, PERMISSIONS } from '@/shared/lib/permissions';

export type AdminTab =
  | 'members'
  | 'teams'
  | 'roles'
  | 'invitations'
  | 'requests'
  | 'notifications'
  | 'audit'
  | 'palettes'
  | 'settings';

/** The sections that exist for the viewer (a plain member sees people and teams only). */
export function visibleTabs(workspace: Workspace): AdminTab[] {
  const p = workspace.permissions;
  const administrates =
    workspace.is_owner ||
    can(p, PERMISSIONS.workspaceManageNotificationPolicy) ||
    can(p, PERMISSIONS.workspaceViewAudit);
  return [
    'members',
    'teams',
    'roles',
    ...(can(p, PERMISSIONS.workspaceManageInvitations) ? (['invitations'] as const) : []),
    ...(can(p, PERMISSIONS.workspaceReviewRequests) || can(p, PERMISSIONS.workspaceReviewTransfers)
      ? (['requests'] as const)
      : []),
    ...(administrates ? (['notifications'] as const) : []),
    ...(can(p, PERMISSIONS.workspaceViewAudit) ? (['audit'] as const) : []),
    'palettes',
    'settings',
  ];
}
